import { SettingConst } from '@faire/web-api--source/types';

/**
 * Experiment setting to enable an increase in the payment terms for OwF.
 * https://www.notion.so/faire/OWF-Terms-Increase-1ad2efb5c25a80789f34d83e54f5c651?d=1af2efb5c25a803a9f1c001c2a1a0f8c#1ae2efb5c25a80fba258ce357348bd00
 */
export const OWF_TERMS_INCREASE_250307 =
  'OWF_TERMS_INCREASE_250307' as SettingConst<
    'OWF_TERMS_INCREASE_250307',
    boolean,
    'RETAILER' | 'VISITOR_WEB'
  >;
